
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.523 12.778l-8.012-2.692a1.588 1.588 0 00-1.029 0l-8.005 2.692a.747.747 0 00-.477.7c0 6.004 2.362 11.66 6.486 15.515A3.672 3.672 0 0030 30c.898 0 1.796-.336 2.514-1.007C36.638 25.138 39 19.483 39 13.477v-.021a.719.719 0 00-.477-.678zm-7.708 12.41c.38 0 .69.32.69.713a.7.7 0 01-.69.715h-1.63a.7.7 0 01-.69-.715c0-.392.31-.714.69-.714h.124v-1.713h-1.595a.705.705 0 01-.691-.714c0-.393.31-.714.69-.714h.45V15.27c0-.186.076-.372.207-.5l1.14-1.186a.706.706 0 01.98 0l1.14 1.186a.709.709 0 01.207.5v6.776h.45c.38 0 .69.321.69.714 0 .392-.31.714-.69.714H30.69v1.713h.124z","fill":"#fff"}})])
          )
        }
      }
    